import { mergeStepArgs } from './mergeStepArgs';
import { StepWizardSchemeError } from '../models';
export function getStepHistoryItem(_ref) {
  var stepCode = _ref.stepCode,
    scheme = _ref.scheme,
    stepArguments = _ref.stepArguments;
  var step = scheme[stepCode];
  if (!step) {
    throw new StepWizardSchemeError("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043D\u0430\u0439\u0442\u0438 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 \u0448\u0430\u0433 ".concat(stepCode, " \u0432 \u0441\u0445\u0435\u043C\u0435. \u0421\u0445\u0435\u043C\u0430 \u043D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u0430."));
  }
  return stepArguments ? mergeStepArgs(step, stepArguments) : step;
}